// extracted by mini-css-extract-plugin
export default {"polls-alerttext-container":"VoteCountdown_polls-alerttext-container__zZDDf","info-circle":"VoteCountdown_info-circle__-9lwz"};